module.exports = __webpack_public_path__ + "static/media/viv_3.17842035.jpg";